class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);
var ShippingCalculator = {
  shop: {
    currency: '{{ shop.currency }}'
  },
  calculatedCep: [],
  calculatingCep: [],
  init: function(calculator, index) {
    this.calculatedCep[index] = '';
    this.calculatingCep[index] = false;

    const zipInput = calculator.querySelector('.js-zip');
    const calculateButton = calculator.querySelector('.js-button');
    const responseContainer = calculator.querySelector('.shipping__response');
    const form = calculator.querySelector('.shipping__form');

    // Check if elements exist before adding listeners
    if (zipInput && calculateButton) {
      zipInput.addEventListener('keyup', async (event) => {
        if (event.keyCode === 13) {
          event.preventDefault();
          await this.handleZipCode(calculator, index, zipInput, form, responseContainer);
        }
      });

      calculateButton.addEventListener('click', async (event) => {
        event.preventDefault();
        await this.handleZipCode(calculator, index, zipInput, form, responseContainer);
      });
    } else {
      console.warn('Element(s) not found in calculator:', calculator);
    }
  },
  handleZipCode: async function(calculator, index, zipInput, form, responseContainer) {
    if (this.calculatingCep[index]) return;
    if (this.calculatedCep[index] === zipInput.value) {
      return;
    }

    this.calculatingCep[index] = true;
    await this.checkZip(form, calculator, responseContainer);
    this.calculatedCep[index] = zipInput.value;
    this.calculatingCep[index] = false;
  },
  checkZip: async function(form, calculator, responseContainer) {
    this.selectors = {
      wrapper: calculator,
      wrapperResponse: responseContainer
    };
    this.renderReponse('', calculator);
    this.showLoading(true, calculator);

    var shipping = {
      zip: form.querySelector('.form__zip').value
    }

    const zipSemHifen = shipping.zip.replace('-', '');

    if (zipSemHifen && zipSemHifen.length != 8) {
      this.showLoading(false, calculator);
      this.renderReponse('Digite um CEP válido.', calculator);
    } else {
      const cart = await this.getCart();
      if (cart.item_count === 0) {
        const variant_id_element = document.querySelector('input[name=variant_id]');
        const variant_id = variant_id_element ? variant_id_element.value : null;

        if (variant_id) {
          await this.addItemCart(variant_id);
          this.getShippingRates(zipSemHifen, true, calculator);
        } else {
          this.showLoading(false, calculator);
          this.renderReponse('Variant ID not found.', calculator);
          console.warn('Variant ID not found.');
        }
      } else {
        this.getShippingRates(zipSemHifen, false, calculator);
      }
    }
  },
  getZip: async function(zip) {
    let zipInfo;
    const url = `//viacep.com.br/ws/${zip}/json`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      zipInfo = await response.json();

      let state;
      switch (zipInfo.uf) {
        case "AC": state = "Acre";
          break;
        case "AL": state = "Alagoas";
          break;
        case "AM": state = "Amazonas";
          break;
        case "AP": state = "Amapá";
          break;
        case "BA": state = "Bahia";
          break;
        case "CE": state = "Ceará";
          break;
        case "DF": state = "Distrito Federal";
          break;
        case "ES": state = "Espírito Santo";
          break;
        case "GO": state = "Goiás";
          break;
        case "MA": state = "Maranhão";
          break;
        case "MG": state = "Minas Gerais";
          break;
        case "MS": state = "Mato Grosso do Sul";
          break;
        case "MT": state = "Mato Grosso";
          break;
        case "PA": state = "Pará";
          break;
        case "PB": state = "Paraíba";
          break;
        case "PE": state = "Pernambuco";
          break;
        case "PI": state = "Piauí";
          break;
        case "PR": state = "Paraná";
          break;
        case "RJ": state = "Rio de Janeiro";
          break;
        case "RN": state = "Rio Grande do Norte";
          break;
        case "RO": state = "Rondônia";
          break;
        case "RR": state = "Roraima";
          break;
        case "RS": state = "Rio Grande do Sul";
          break;
        case "SC": state = "Santa Catarina";
          break;
        case "SE": state = "Sergipe";
          break;
        case "SP": state = "São Paulo";
          break;
        case "TO": state = "Tocantíns";
          break;
        default: state = "Estado não encontrado";
      }
      zipInfo.state = state;
    } catch (error) {
      console.error('Error fetching zip info:', error);
      return null;
    }
    return zipInfo;
  },
  getCart: async function() {
    let cart;
    const url = '/cart.json';

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      cart = await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return { item_count: 0 };
    }
    return cart;
  },
  addItemCart: async function(variant_id) {
    const url = '/cart/add.js';
    const data = {
      id: variant_id,
      quantity: 1
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return true;
    } catch (error) {
      console.error('Error adding item to cart:', error);
      return false;
    }
  },
  getShippingRates: async function(zip, clear, calculator) {
    const zipInfo = await this.getZip(zip);

    if (!zipInfo) {
      this.showLoading(false, calculator);
      this.renderReponse('CEP não encontrado.', calculator);
      return;
    }

    const url = `/cart/shipping_rates.json?shipping_address[zip]=${
      zipInfo.cep
    }&shipping_address[country]=Brazil&shipping_address[province]=${
      zipInfo.state
    }`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      this.renderShippingRates(data.shipping_rates, calculator);

      if (clear === true) {
        await fetch('/cart/clear.js', {});
        return true;
      }
    } catch (error) {
      console.error('Error fetching shipping rates:', error);
      this.showLoading(false, calculator);
      this.renderReponse('Erro ao buscar as taxas de envio.', calculator);
    }
  },
  showLoading: function(value, calculator) {
    const responseContainer = calculator.querySelector('.shipping__response');
    const calculateButton = calculator.querySelector('.shipping__form .js-button');

    if (responseContainer && calculateButton) {
      if (value) {
        responseContainer.classList.add('loading');
        calculateButton.disabled = true;
      } else {
        responseContainer.classList.remove('loading');
        calculateButton.disabled = false;
      }
    }
  },
  renderShippingRates: function(shippingRates, calculator) {
    let template = '';
    this.showLoading(false, calculator);
    const responseContainer = calculator.querySelector('.shipping__response');

    if (shippingRates && shippingRates.length > 0) {
      const listRates = document.createElement('ul');
      listRates.classList.add('response__rates');
      let template_li = '';
      for (item of shippingRates) {
        template_li += `
                  <li> 
                      <span> ${item.name} - <strong>${this.formatPrice(Number(item.price))}</strong></span>
                      <span><strong>Entrega em - ${item.delivery_days[0]} dia(s) útil(eis)</strong></span>
                  </li>				
              `;
      }
      listRates.innerHTML = template_li;
      responseContainer.innerHTML = '';
      responseContainer.appendChild(listRates);
    } else {
      this.renderReponse('Nós não entregamos para esse endereço.', calculator);
    }
  },
  renderReponse: function(message, calculator) {
    const responseContainer = calculator.querySelector('.shipping__response');
    if (responseContainer) {
      responseContainer.innerHTML = message;
    }
  },
  formatPrice: function(price) {
    return new Intl.NumberFormat('pt-br', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.querySelector('.widget_shopping_cart');
  if (!targetNode) return;
  const config = {
    attributes: true,
    childList: true,
    subtree: true
  };
  const callback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const shippingCalculators = document.querySelectorAll('.js-shipping-calculator');

        shippingCalculators.forEach((calculator, index) => {
          ShippingCalculator.init(calculator, index);
        });
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    window.discountCodesFunction();
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            const shippingCalculators = document.querySelectorAll('.js-shipping-calculator');
    
            shippingCalculators.forEach((calculator, index) => {
              ShippingCalculator.init(calculator, index);
            });


            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          window.discountCodesFunction();

        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
          window.discountCodesFunction();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        const cartQuantity = document.querySelector(
          "header .cart-count-bubble span:first-child"
        );
        const cartHeaderBottomQuantity = document.querySelector(
          ".cart-link .cart-count-bubble span:first-child"
        );
        const cartHeaderBottomBubble = document.querySelector(
          ".cart-link .cart-count-bubble"
        );

        if (cartQuantity) {
          if (cartHeaderBottomQuantity) {
            cartHeaderBottomQuantity.textContent = cartQuantity.textContent;
          }
        } else {
          cartHeaderBottomQuantity.textContent = 0;
          cartHeaderBottomBubble.classList.add("visually-hidden");
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
